module.exports = __webpack_public_path__ + "static/img/wisdomZhili3.ee74dbdc.png";